import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { moduloPerform } from '../../diccionarios/performValuesModulo';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { CommonService } from 'src/app/shared/utils/common.service';
import { Linea } from '../../models/linea';
import { DiccionarioTvc } from '../../models/diccionarioTvcInterface';

@Injectable({
  providedIn: 'root'
})
export class LineaService {

  headers: HttpHeaders;
  tvcModulo: DiccionarioTvc;

  urlLinea: string;
  urlProducto: string;
  urlLineaHomologada: string;

  url: string;

  constructor(private http: HttpClient,
    private utilService: UtilsService,
    private commom: CommonService) {
    this.tvcModulo = moduloPerform;
    this.urlLinea = this.utilService.getQueryTvc(this.tvcModulo.url.datosMaestros.linea);
    this.urlProducto = this.utilService.getQueryTvc(this.tvcModulo.url.datosMaestros.producto);
    this.url = this.utilService.getQueryTvc('');
  }

  getAll() {
    const headers = this.utilService.getHeaders();
    return this.http.get<Linea[]>(this.urlLinea, { headers });
  }

  getById(innId) {
    return this.commom.peticionGetConHeader(this.urlLinea + '/lineasByCodigoPlanta/' + innId);
  }

  lineasByCodigoPlantaActiva(innId: number) {
    return this.commom.peticionGetConHeader(this.urlLinea + '/lineasByCodigoPlantaActiva/' + innId);
  }

  save(innLinea) {
    const headers = this.utilService.getHeaders();
    return this.http.post<Linea>(this.urlLinea, innLinea, { headers });
  }

  update(innLinea) {
    const headers = this.utilService.getHeaders();
    return this.http.put<Linea>(this.urlLinea, innLinea, { headers });
  }

  delete(inId) {
    const headers = this.utilService.getHeaders();
    return this.http.delete(this.urlLinea + '/' + inId, { headers });
  }

  getProductosPorLinea(innIdLinea) {
    const headers = this.utilService.getHeaders();
    return this.http.get<any[]>(this.urlProducto + '/' + this.tvcModulo.url.parada.getProductosPorLineas + '/' + innIdLinea, { headers });
  }

  updateCentroCostos(innObjLinea: any) {
    const headers = this.utilService.getHeaders();
    return this.http.put<any>(this.urlLinea + '/centro_costo', innObjLinea, { headers });
  }

  getPlantaPersonaActivas(username: string) {
    return this.commom.peticionGetConHeader(this.urlLinea + '/planta-persona-activas/' + username);
  }

  saveLineaHomologada(innObj: any) {
    return this.commom.peticionPostConHeader(this.url + this.tvcModulo.url.datosMaestros.lineaHomologada, innObj);
  }

  getLineaBaanMaquina(linea: string) {
    return this.commom.peticionGetConHeader(this.url + this.tvcModulo.url.datosMaestros.baanMaquina + `/${linea}`);
  }

  getLineaBaanMaquinaByLinea(linea: string) {
    return this.commom.peticionGetConHeader(this.url + this.tvcModulo.url.datosMaestros.lineaHomologada + `/${linea}`);
  }

  getAllLineaBaanMaquina(){
    return this.commom.peticionGetConHeader(this.url + this.tvcModulo.url.datosMaestros.baanMaquina);
  }

  getLineaBaanMaquinaByMcno(mcno: string){
    return this.commom.peticionGetConHeader(this.url + this.tvcModulo.url.datosMaestros.baanMaquina+'/id'+ `/${mcno}`);
  }

  getByIdbySap(innId) {
    return this.commom.peticionGetConHeader(this.urlLinea + '/lineasByCodigoPlantaSap/' + innId);
  }

  getByIdbyPerfor(innId) {
    return this.commom.peticionGetConHeader(this.url + this.tvcModulo.url.datosMaestros.lineaPerfor + `/${innId}`);
  }

}